<template>
    <div class="vh-100">
        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left">
                    <div class="header-item" data-toggle="modal" data-target="#myModalclose">
                        <div class="icon-24 icon-x-blue"></div>
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Daftar</div>
                <div class="header-top--right">
                    <div class="header-item"></div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <main class="content-wrapper main-page flex-100">

            <div class="p-y-16 p-x-20 w-limit flex-1">
                <div class="badge-tag tg-blue f-14">
                    Langkah <b>2 / 3</b>
                </div>
                <div class="f-16 m-t-16">
                    Kode verifikasi telah dikirim ke nomor {{telpNumber}}, <b>Periksa Whatsapp Anda</b> & masukkan kode.
                </div>
                <div
                    class="row justify-content-center align-items-center remove-padding-margin col-md-12 col-sm-12 col-12 col-lg-12 offset-lg-12">
                    <div class="col-md-12 remove-padding otp-wrapper">
                        <InputOtp :bindButton="'#verifikasi'" @onComplete="setOtpCode" />
                        <div class="f-13 m-t-32 text-center" id="textTimer">
                            <span class="f-c-midgrey">Kode akan dikirim ulang dalam </span>
                            <span><Countdown :timeleft="timeleft" @callbackCountdown="countdownTimeout" ref="countdown" /></span>
                        </div>
                        <div class="code-otp text" style="display: none" id="textTimer-loading">
                          Kode sedang dikirim ...
                        </div>
                        <vue-recaptcha
                            ref="recaptcha"
                            @verify="onCaptchaVerified"
                            @expired="onCaptchaExpired"
                            size="invisible"
                            sitekey="6Lc_X9QZAAAAAI0vmQNzNDQG-rKZ7NOE0O3wq5W9">
                        </vue-recaptcha>
                        <div class="f-13 m-t-32 text-center" id="linkKirimUlang">
                            <span class="f-c-midgrey">Belum menerima kode? </span>
                            <a class="f-c-blue" @click="getOTP">Kirim Ulang Kode</a>
                        </div>

                    </div>
                </div>
            </div>

            <div class="p-x-20 p-y-20 w-limit">
                <div class="f-13 m-d-20 text-center">
                    <span class="f-c-midgrey">Nomor salah? </span>
                    <a class="f-c-blue" data-toggle="modal" data-target="#modalTimeout">Ubah Nomor</a>
                </div>
                <button class="btn smart-primary" id="verifikasi" @click="sendVerificationCode">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        v-if="isClicked === true"></span>
                    <span id="textbtn">
                        Verifikasi
                    </span>
                </button>
            </div>

        </main>

        <!-- MODALs -->
        <div class="modal fade" id="myModalclose" role="dialog">
            <div class="modal-dialog modal-lg bani-modal">
                <div class="modal-content">
                    <div class="modal-head w-limit">
                        <div class="modal-head--left"></div>
                        <div class="f-16 f-bold">Batalkan Pendaftaran</div>
                        <div class="modal-head--right" data-dismiss="modal">
                            <div class="icon-24 icon-x-blue"></div>
                        </div>
                    </div>
                    <div class="separator-line"></div>
                    <div class="modal-bodyy w-limit w-100 p-x-20">

                        <div class="m-t-16 f-16">
                            Yakin ingin membatalkan pendaftaran akun Smartlink Owner?
                        </div>

                        <div class="button-wrapper m-t-4 p-y-20 w-limit w-100">
                            <button type="button" class="btn smart-secondary" data-dismiss="modal" @click="cancel">Ya,
                                Batalkan</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalTimeout" role="dialog">
            <div class="modal-dialog modal-lg bani-modal">
                <div class="modal-content">
                    <div class="modal-head w-limit">
                        <div class="modal-head--left"></div>
                        <div class="f-16 f-bold">Cek Nomor Anda</div>
                        <div class="modal-head--right" data-dismiss="modal">
                            <div class="icon-24 icon-x-blue"></div>
                        </div>
                    </div>
                    <div class="separator-line"></div>
                    <div class="modal-bodyy w-limit w-100 p-x-20">

                        <div class="m-t-16 f-16">
                            Kami telah beberapa kali mengirim kode OTP ke nomor {{ telpNumber }}. Apakah Anda yakin ini
                            nomor yang benar?
                        </div>

                        <div class="button-wrapper m-t-4 p-y-20 w-limit w-100">
                            <button type="button" class="btn smart-secondary" data-dismiss="modal" @click="cancel">Ubah
                                Nomor</button>
                            <div class="f-13 m-t-12 text-center">
                                <span class="f-c-midgrey">Ya, nomor benar. </span>
                                <a class="f-c-blue" @click="">Kunjungi Pusat Bantuan</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Countdown from "../../component-items/Countdown";
    import InputOtp from "../../component-items/InputOtp";
    import VueRecaptcha from 'vue-recaptcha';

    export default {
        components: {
            Countdown,
            InputOtp,
            'vue-recaptcha': VueRecaptcha,
        },
        name: "VerifikasiRegis",
        data() {
            return {
                isClicked: false,
                timer: "",
                telpNumber: "",
                kode: "",
                nomorTelp: "",
                code_1: "",
                code_2: "",
                code_3: "",
                code_4: "",
                code_5: "",
                code_6: "",
                timeHandler: null,
                dataLoop: 1,

                timeleft: 0,

                otp: "",
            }
        },
        mounted() {
            $('#linkKirimUlang').hide();
            $('.first').focus();
            var telpLocal = "+" + localStorage.getItem("telp");
            this.telpNumber = telpLocal;
            this.nomorTelp = telpLocal;
            $('#close').hide()

            this.timeleft = 120;
            this.dataLoop = 1;
        },
        beforeDestroy() {
            this.$refs.countdown.stop()
        },
        methods: {
          submit() {
            $('#linkKirimUlang').hide();
            $('#textTimer').hide();
            $("#textTimer-loading").show()
            this.$refs.recaptcha.execute();
          },
          onCaptchaVerified: async function (recaptchaToken) {
            await this.getOTP(recaptchaToken)
            const self = this;
            self.$refs.recaptcha.reset();
          },
          onCaptchaExpired: function () {
            this.$refs.recaptcha.reset();
          },

            cancel() {
                this.$refs.countdown.stop()
                this.$router.push('/register')
            },

            nextInputCode(event) {
                var nums = event.target.value;
                var number = nums.replace(/[^0-9]+/, '');
                event.target.value = number;
                if (this.code_1 != "" && this.code_2 != "" && this.code_3 != "" && this.code_4 != "" && this.code_5 !=
                    "" && this.code_6 != "") {
                    this.sendVerificationCode()
                    $('#verifikasi').prop('disabled', true)
                } else {
                    if ((event.target.value.length == event.target.maxLength) && number !== '') {
                        $(event.target).next('.inputs').focus();
                    }
                }
            },

            prevInputCode(event) {
                if (event.target.value == '') {
                    if (event.keyCode == 8) {
                        $(event.target).prev('.inputs').focus();
                        $('#verifikasi').prop('disabled', true);
                    }
                }
            },

            async getOTP() {
                $('#linkKirimUlang').hide();
                $('#textTimer').hide();
                $("#textTimer-loading").show()
                var loop = this.dataLoop + 1;
                this.dataLoop = loop;
                try {
                    var noTelp = localStorage.getItem("telp");
                    const dataotp = new FormData;
                    dataotp.append('telp', noTelp);
                    const res = await this.$axios.post(this.$baseurl + '/auth/send_otp', dataotp)
	                if (!res.data.status) {
	                	this.$toast.error(res.data.msg)
		                this.$router.push('/register')
	                }

                    this.timeleft = 120;
                    $('#linkKirimUlang').hide();
                    $('#textTimer').show();
                    $("#textTimer-loading").hide()
                } catch (e) {
                    this.$catch_error_response(e)

                    $('#linkKirimUlang').show();
                    $('#textTimer').hide();
                    $("#textTimer-loading").hide()

                    this.$router.push('/register')
                }
            },

            async sendVerificationCode() {
                this.isClicked = true
                $('#textbtn').hide()
                try {
                    const dataotp = new FormData
                    var telpOtp = localStorage.getItem('telp');
                    dataotp.append('telp', telpOtp)
                    dataotp.append('otp', this.otp)
                    const response = await this.$axios.post(this.$baseurl + '/auth/verifyotp', dataotp)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            this.registSingleAccount();
                        } else {
	                        this.$toast.error(response.data.msg)

                            this.isClicked = false
                            $('#textbtn').show();
                            $('#verifikasi').prop('disabled', false);
                        }
                    }
                } catch (e) {
                    this.$catch_error_response(e)

                    this.isClicked = false
                    $('#textbtn').show();
                    $('#verifikasi').prop('disabled', false);
                }
            },

            async registSingleAccount() {
                try {
                    var telp = localStorage.getItem('telp');
                    const res = await this.$axios.get(this.$baseurl + '/auth/cek_owner?telp=' + telp)
                    var arrayData = res.data.data;
                    var lenghtData = arrayData.length;
                    if (lenghtData === 0) {
                        this.$router.push('/flowregis1')
                    } else {
                        localStorage.setItem("super_owner_key", arrayData[0].superowner.password);
                        this.$router.push('/akunregister')
                    }
                } catch (e) {
                	this.$catch_error_response(e)
                	
	                this.isClicked = false
	                $('#textbtn').show();
	                $('#verifikasi').prop('disabled', false);
                }
            },
            setOtpCode(otp) {
                this.otp = otp

                this.sendVerificationCode();
            },
            countdownTimeout() {
                this.timeleft = 0;

                if (this.dataLoop === 3) {
                    $('#modalTimeout').modal('show');
                }

                $('#linkKirimUlang').show();
                $('#textTimer').hide();
                $("#textTimer-loading").hide()
            },

        },


    }
</script>

<style scoped>

</style>